<template>
  <b-modal centered :visible="show" hide-footer hide-header no-close-on-backdrop no-close-on-esc>
    <b-container>
      <b-row>
        <b-col>
          <h4 class="text-info">{{ $t("globals.import_exact_parking") }}:</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <input type="file" ref="file" accept=".csv" @change="handleFileUpload()" />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn class="float-right" variant="success" @click="submitFile" :disabled="uploadDisabled">
            {{ $t("globals.submit") }}
          </b-btn>
          <b-btn @click="cancelModal" variant="warning">
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
      <a href="" id="downloadlink" ref="csvfiledownload" hidden="true" download=""></a>
    </b-container>
  </b-modal>
</template>

<script>
import axios from "axios";
import { mapGetters, mapMutations } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function
  },
  data() {
    return {
      file: "",
      fileData: ""
    };
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    cancelModal() {
      this.file = "";
      this.fileData = "";
      this.close();
    },
    submitFile() {
      this.getBase64(this.file).then(data64 => {
        this.setShowLoadingModal(true);
        let data = {
          query: `
            mutation ExactImportParkingInvoices ($exact_list: String) {
              ExactImportParkingInvoices (exact_list: $exact_list)
            }
          `,
          variables: {
            exact_list: data64
          }
        };

        this.setShowLoadingModal(true);
        axios
          .post(this.getGraphQlUrl, data, this.getDefConf)
          .then(res => {
            console.log(res);
            if (res.data.errors !== undefined && res.data.errors.length > 0) {
              alert(res.data.errors[0].message);
            } else {
              this.downloadCSV(res.data.data.uploadExact[0], false);
              if (res.data.data.uploadExact[1].length > 0) {
                this.downloadCSV(res.data.data.uploadExact[1], true);
              }
            }
          })
          .catch(err => {
            alert(err);
            console.error(err);
          })
          .then(() => {
            this.setShowLoadingModal(false);
            this.cancelModal();
          });
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    downloadCSV(csv, error) {
      let d = new Date();

      let d_string = `${d.getUTCFullYear()}-`;
      d_string += `${("0" + (d.getUTCMonth() + 1)).slice(-2)}-`;
      d_string += `${("0" + d.getUTCDate()).slice(-2)}`;

      let link = document.getElementById("downloadlink");
      link.href = "data:Application/octet-stream," + encodeURIComponent(csv);
      link.style.display = "block";
      if (error) {
        link.download = `Import_parking_log_${d_string}.csv`;
      } else {
        link.download = `Straetus_parking_${d_string}.csv`;
      }
      link.click();
    }
  },
  computed: {
    ...mapGetters([
      "getDefConf",
      "getGraphQlUrl",
      "getUserSystem",
      "getUserBrandPermissions"
    ]),
    uploadDisabled() {
      return this.file === "";
    }
  }
};
</script>
